import type { TypedMyBrandPolicy } from './-MyBrandPolicy';
import RawMyBrandPolicy from './MyBrandPolicy.vue';
export * from './-MyBrandPolicy';
export const MyBrandPolicy = RawMyBrandPolicy as typeof TypedMyBrandPolicy;
